<div
  class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 text-black"
>
  <div class="flex flex-col max-h-[80%] max-w-[80%] overflow-auto">
    @if (image()) {
    <img
      [src]="image()"
      alt="modal"
      class="w-full object-cover w-[51.5rem] h-[15rem] rounded-t-lg"
    />
    }

    <div
      class="bg-white flex flex-col gap-[1.5rem] px-[2.5rem] py-[1.5rem]"
      [class.rounded-lg]="!image()"
      [class.rounded-b-lg]="image()"
    >
      @if (type() === "primary" && showClose()) {
      <app-button
        [text]="'components.modal.close' | transloco"
        [icon]="'close'"
        [iconSize]="'1.3125rem'"
        (buttonClick)="closeModal.emit()"
        class="w-fit self-end"
      ></app-button>
      }

      <h3>{{title()}}</h3>
      @if(text()) {
      <p [innerHTML]="text() | safeHtml" class="wysiwyg"></p>
      }
      <div class="flex items-center gap-2 w-full justify-center">
        @if(type() == "secondary") {
        <app-button
          [text]="'components.modal.cancel' | transloco"
          [variant]="'secondary'"
          (buttonClick)="closeModal.emit()"
          class="flex-1"
        ></app-button>
        }
        <app-button
          [text]="buttonText()"
          [variant]="type() == 'primary' ? 'secondary' : 'destructive'"
          (buttonClick)="completeModal.emit()"
          class="flex-1"
        ></app-button>
      </div>
    </div>
  </div>
</div>
